/**
 * Yarn Founder Story / Video Section Interactive Logic
 * Upload to: assets/yarn-founder-story.js
 */

(function () {
  'use strict';

  function initSection(root) {
    if (!root || root.dataset.yvsInit === 'true') return;
    root.dataset.yvsInit = 'true';

    // 1. Video Play Trigger
    var card = root.querySelector('[data-yvs-video-card]');
    if (card) {
      var playBtn = card.querySelector('[data-yvs-play]');
      var video = card.querySelector('video');
      var iframe = card.querySelector('iframe');

      function startPlayback() {
        card.classList.add('is-playing');
        if (video) {
          video.controls = true;
          video.play().catch(function () {});
        } else if (iframe) {
          var src = iframe.getAttribute('src') || iframe.dataset.src;
          if (src) {
            if (src.indexOf('autoplay=1') === -1) {
              src += (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1';
            }
            iframe.setAttribute('src', src);
          }
        }
      }

      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          startPlayback();
        });
      }

      card.addEventListener('click', function () {
        if (!card.classList.contains('is-playing')) {
          startPlayback();
        }
      });
    }

    // 2. Intersection Observer for Entrance Animation
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.add('is-inview');
              root.classList.remove('is-offscreen');
            } else {
              root.classList.add('is-offscreen');
            }
          });
        },
        { threshold: 0.12 }
      );
      observer.observe(root);
    } else {
      root.classList.add('is-inview');
    }
  }

  function initAll() {
    document.querySelectorAll('[data-yarn-founder-story]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Customizer Support
  document.addEventListener('shopify:section:load', function (event) {
    var root =
      event.target.querySelector('[data-yarn-founder-story]') ||
      (event.target.matches('[data-yarn-founder-story]') ? event.target : null);
    if (root) {
      root.removeAttribute('data-yvs-init');
      initSection(root);
    }
  });
})();
